import { Injectable } from '@angular/core';
import { Configuration } from './configuration.data';
import { environment } from 'src/environments/environment';

@Injectable()
export class ApplicationData {

  private _lang: string;
  private _configuration: Configuration;
  private _userProjectFolder: string = '';
  private _userProjectName: string = '';
  private _userProjectId: number = 0;

  /**
	 * Constructor
	 */
  constructor() {

  }

  /**
	 * Lang
	 */
  public get lang(): string {
    return this._lang;
  }
  public set lang(value: string) {
    this._lang = value;
  }


  /**
	 * Current user project folder
	 */
  public get userProjectFolder(): string {
    return this._userProjectFolder;
  }
  public set userProjectFolder(value: string) {
    this._userProjectFolder = value;
  }

  /**
	 * User Project Name
	 */
  public get userProjectName(): string {
    return this._userProjectName;
  }
  public set userProjectName(value: string) {
    this._userProjectName = value;
  }

  /**
	 * User Project Id
	 */
  public get userProjectId(): number {
    return this._userProjectId;
  }
  public set userProjectId(value: number) {
    this._userProjectId = value;
  }

  /**
	 * Configuration
	 */
  public get configuration(): Configuration {
    return this._configuration;
  }
  public set configuration(value: Configuration) {
    this._configuration = value;
  }
}
